import { dateFromDicomString } from "../commons/dicom";
import { stringOrEmpty } from "../commons/utils";
import moment from "moment";

/**
 * A DICOM study.
 */
export interface Study {
  /** Study Instance UID (0020,000D) */
  uid: string;
  /** Study Description (0008,1030) */
  description: string;
  /** Study Date (0008,0020) */
  date: Date;
}

/**
 * Create a new study object.
 * @param uid The study instance uid.
 * @param description The study description. Default: ""
 * @param date The study date. Default: current date.
 * @returns A study object
 */
export const createStudy = (
  uid: string,
  description: string = "",
  date: Date = new Date()
): Study => ({
  uid: uid,
  description: description,
  date: date,
});

/**
 * Update the study from a DICOM dataset.
 * @param study The study.
 * @param dataset The DICOM dataset.
 */
export const updateStudy = (study: Study, dataset: any) => {
  if (study === undefined) return;
  updateDescription(study, dataset);
  updateDate(study, dataset);
};

/////////////////////////////////////////////////////////////

const updateDescription = (study: Study, dataset: any) => {
  if (study.description.length === 0) {
    study.description = stringOrEmpty(dataset.string("x00081030"));
  }
};

const updateDate = (study: Study, dataset: any) => {
  const date = moment(dateFromDicomString(stringOrEmpty(dataset.string("x00080020")))).toDate();
  // only set if new date is older
  if (date && date < study.date) study.date = date;
};
